import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import api from '../../services/Api';

import { submittedRegistrationAction } from '../../actions/RegistrationFormActions';
import { setPaymentConfig, setPaymentError, setRepeatPaymentError } from '../../actions/AdyenPaymantActions';
import { networkErrorAction } from '../../actions/UiActions';

import { formatErrors } from '../../components/payments/adyen/Adyen/utils';

import PaymentRepeating from './component';

const getRepeatPaymentData = (registrationId, error) => (dispatch) => {
	return api.post(`/payment/repeat/${registrationId}`, {}).then(res => {
		if (res.data) {
			res.data.registration && dispatch(submittedRegistrationAction(res.data.registration));
			res.data.details && dispatch(dispatch(setPaymentConfig({ ...res.data.details, isAdyenRepeatPayment: true })));
		}

		dispatch(setPaymentError([error]));
	}).catch((error) => {
		if (error.response && error.response.status === 422) {
			const data = error.response.data;
			dispatch(setRepeatPaymentError(formatErrors(data.error, data.errors)));
		}
		else {
			dispatch(networkErrorAction(error));
		}
	});
};

const mapStateToProps = (state) => {
	const {
		adyenPayment,
		raffleForm: {
			registration
		}
	} = state;

	return {
		payment: adyenPayment,
		registration,
		registrationId: registration ? registration.id : null
	};
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
	getRepeatPaymentData
}, dispatch);

const PaymentRepeatingContainer = connect(mapStateToProps, mapDispatchToProps)(PaymentRepeating);

export default PaymentRepeatingContainer;



// WEBPACK FOOTER //
// ./routes/paymentRepeating/container.js